import { useQuery } from '@tanstack/react-query';

import rateCodeService from '~/services/cruises/RateCodeService';

import { rateCodeQueryKeys } from './rateCodeQueryKeys';

export const RECENT_RATE_CODES_LIMIT = 50;

export interface RecentlyCreatedRateCodesParams {
  createdAtStart: string;
  createdAtEnd?: string;
}

export function useGetRecentlyCreatedRateCodes(params: RecentlyCreatedRateCodesParams | null) {
  return useQuery({
    queryKey: rateCodeQueryKeys.recentlyCreated(params?.createdAtStart ?? null, params?.createdAtEnd ?? null),
    queryFn: async () => {
      return await rateCodeService.getRateCodeList({
        ...params!,
        take: RECENT_RATE_CODES_LIMIT,
      });
    },
    enabled: !!params,
  });
}
